import React, { PureComponent } from 'react';
import { CLOUD_TYPE_IDS } from 'users/constants/usersConstants';
import SearchIcon from 'mdi-react/SearchIcon';
import { Collapse } from 'reactstrap';
import { AwsCommonFields, awsCommonFieldToDisplayField } from '../constants/awsConstants';
import { K8S_POD_LABELS } from '../constants/appConstants.js';
import styles from './GroupByFilterButton.module.scss';

const mapItemNameToItemSymbol = new Map([
  ['Tag Groups', 'virtualTag'],
  ['Tags', 'customTag'],
  ['Enrichment Tags', 'accountTag'],
  ['Virtual Tags', 'governancetags'],
  ['Labels', 'label'],
  [awsCommonFieldToDisplayField.get(AwsCommonFields.K8S_CUSTOM_TAGS), 'label'],
  ['Views', 'viewsTag'],
  ['Business Mapping Viewpoints', AwsCommonFields.BUSINESS_MAPPING_VIEWPOINTS],
]);

const gcpMapItemNameToItemSymbol = new Map([
  ['Tag Groups', 'virtualTag'],
  ['Tags', 'customTag'],
  ['Enrichment Tags', 'accountTag'],
  ['Virtual Tags', 'governancetags'],
  ['Labels', 'customTag'],
  [K8S_POD_LABELS, 'label'],
  ['Views', 'viewsTag'],
  ['Business Mapping Viewpoints', AwsCommonFields.BUSINESS_MAPPING_VIEWPOINTS],
]);
export default class GroupBySecondLevelDropDownWithSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
    };
  }

  getItemNameToItemSymbolByCloudType = (cloudType, item) => {
    let itemName = item;
    if (cloudType === CLOUD_TYPE_IDS.GCP) {
      itemName = gcpMapItemNameToItemSymbol.get(item);
      return itemName;
    }
    itemName = mapItemNameToItemSymbol.get(item);
    return itemName;
  };

  handleClick = (item, handler) => {
    // handler(item);
    handler(this.props.itemsValuesMap.get(item), this.props.isSecondary);
    if (this.props.toggleCollapse) {
      this.props.toggleCollapse();
    }
  };

  handleSearchInputChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ searchValue });
  };

  renderItems = (items, handler) =>
    items.map((item) => (
      <p className={styles.menuItem} key={item} onClick={() => this.handleClick(item, handler)}>
        {/* {item.replace(`${mapItemNameToItemSymbol.get(this.props.item)}:`, '')} */}
        {item.replace(`${this.getItemNameToItemSymbolByCloudType(this.props.currentCloudType, this.props.item)}:`, '')}
      </p>
    ));

  render() {
    const { secondaryCollapse, handler, secondLevelItems, simpleList } = this.props;
    const secondaryListItemsByItemType = simpleList
      ? secondLevelItems
      : secondLevelItems.filter(
          (item) =>
            item.split(':')[0] ===
            this.getItemNameToItemSymbolByCloudType(this.props.currentCloudType, this.props.item),
        );
    const { searchValue } = this.state;
    if (!secondaryListItemsByItemType || secondaryListItemsByItemType.length === 0) {
      return null;
    }
    const filteredList = !searchValue.length
      ? secondaryListItemsByItemType
      : secondaryListItemsByItemType.filter((item) => item.toLowerCase().includes(searchValue.toLowerCase()));
    return (
      <Collapse isOpen={secondaryCollapse} className={styles.secondMenu}>
        <div>
          {this.props.secondLevelItems.length > 5 && (
            <div className={styles.searchInputContainer}>
              <SearchIcon />
              <input
                placeholder="Search"
                className={styles.searchInput}
                value={searchValue}
                onChange={(e) => this.handleSearchInputChange(e)}
                autoComplete="off"
              />
            </div>
          )}
          <div style={{ width: '100%' }}>{this.renderItems(filteredList, handler)}</div>
        </div>
      </Collapse>
    );
  }
}
